import React, { useEffect, createElement } from 'react';
import { TopProofBar } from './components/TopProofBar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainPoints } from './components/PainPoints';
import { MethodSection } from './components/MethodSection';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { UrgencyBar } from './components/UrgencyBar';
import { PurchaseSection } from './components/PurchaseSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '27856287660637797');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans" data-id="element-0">
      <TopProofBar data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProofBar data-id="element-3" />
      <PainPoints data-id="element-4" />
      <MethodSection data-id="element-5" />
      <ProductShowcase data-id="element-6" />
      <Bonuses data-id="element-7" />
      <UrgencyBar data-id="element-8" />
      <PurchaseSection id="compra" data-id="element-9" />
      <Testimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <ClosingCTA data-id="element-13" />
      <PurchaseSection data-id="element-14" />
      <Footer data-id="element-15" />
      <SocialProofPopup data-id="element-16" />

      <noscript data-id="element-17">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=27856287660637797&ev=PageView&noscript=1" alt="" data-id="element-18" />
      </noscript>
    </div>;
}